import React from "react";
import { Row, Space, Typography } from "antd";
import metaData from "../data/metaData";

const { Text, Paragraph } = Typography;

const Meta = ({ image, title, description, maxWidth, ...props }) => {
  return (
    <Row align="middle" {...props}>
      {image}
      <Space.Compact
        direction="vertical"
        style={maxWidth ? { maxWidth, marginLeft: "0.5rem" } : { marginLeft: "0.5rem" }}
      >
        {title}
        <Text
          style={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            color: "var(--ion-color-step-400)",
          }}
        >
          {description}
        </Text>
      </Space.Compact>
    </Row>
  );
};

export default Meta;
